<div class="pwa-install-prompt" *ngIf="shouldShowInstallPrompt()">
	<img src="https://staticassets.goreact.com/logo-goreact-spot-2022.svg" class="logo" alt="GoReact">
	<button class="btn-none download-btn" translate="pwa-install-message" (click)="showiOSorAndroidInstall()"></button>
	<button class="btn-none close-btn" aria-label="dismiss pwa install prompt" (click)="setHasSeenPWAInstallPrompt()">
		<i class="ficon-times"></i>
	</button>
</div>
